export enum ShippingSupportedServices {
  INSTANT_PAPER = 'instant_paper',
  INSTANT_INK = 'instant_ink'
}
